/** API route map: URLS.Controller.BillingEvent */
export const BillingEvent = {
      Name: 'BillingEvent/',
      GetAll: 'get-all-billing-events',
      Add: 'add-billing-event',
      Delete: 'delete-billing-event',
      Update: 'update-billing-event',
      GetBillingEvents: 'get-billing-events',
};
